// Nova's room-takeover audio cue — a short generated tone (no asset to host),
// so a critical risk or SOS reaches the VA even if they're looking away from
// the screen. Distinct two-tone alarm for SOS, a single soft chime for Nova
// risk takeovers, so they're tell-apart by ear alone.
let ctx = null;

export function playChime(kind = "risk") {
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    const now = ctx.currentTime;
    const freqs = kind === "sos" ? [880, 660, 880, 660] : [660, 880];
    const dur = kind === "sos" ? 0.12 : 0.16;
    freqs.forEach((f, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = f;
      gain.gain.value = 0.0001;
      osc.connect(gain);
      gain.connect(ctx.destination);
      const t0 = now + i * dur;
      gain.gain.exponentialRampToValueAtTime(0.16, t0 + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, t0 + dur - 0.02);
      osc.start(t0);
      osc.stop(t0 + dur);
    });
  } catch {
    // audio context unavailable (no user gesture yet, etc.) — silently skip
  }
}
